import { isEqual, uniqueId } from 'lodash';
import { useEffect, useState } from 'react';
import usePrevious from '@dashboard/hooks/usePrevious';

const ignoreKeys = [
  'sendEmailConfirmation',
  'files',
  'updatedAt',
  'afterPaymentAction',
  'name',
];

function getPageWithoutIgnoreKeys(page) {
  const newPage = { ...page };
  ignoreKeys.forEach(key => delete newPage[key]);
  return newPage;
}

export default function usePreviewKey(page, deps) {
  const [previewKey, setPreviewKey] = useState(uniqueId());
  const previousPage = usePrevious(page) || {};

  useEffect(() => {
    if (!page) return;

    const pageWithoutIgnoreKeys = getPageWithoutIgnoreKeys(page);
    const previousPageWithoutIgnoreKeys =
      getPageWithoutIgnoreKeys(previousPage);

    if (isEqual(pageWithoutIgnoreKeys, previousPageWithoutIgnoreKeys)) return;

    // don't rerender checkout if sendEmailConfirmation is being changed to false
    if (
      previousPage &&
      previousPage.sendEmailConfirmation !== page.sendEmailConfirmation &&
      page.sendEmailConfirmation === false
    ) {
      return;
    }

    setPreviewKey(uniqueId());
  }, [page, previousPage, deps]);

  function setKey(key) {
    setPreviewKey(key || uniqueId());
  }

  return [previewKey, setKey];
}
